export const environment = {
    isProxy: true,
    prefixURL: 'api/',
    prefix: 'api',
    //apiURL: 'https://npctest.e-life.com.ua',
     apiURL: 'https://ecatalog.moz.gov.ua',
    production: true,
    catalogLink: 'https://moz.gov.ua/uk/nacionalnij-katalog-cin',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
